import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import {
  customerActions,
  getCustomerById,
  updateCustomer,
} from "../../../../redux/reducer/customer/customerReducer";
import { getData } from "../../../../service/Service";
import { Settings } from "@mui/icons-material";
import { getCustomerGroup } from "../../../../redux/reducer/customerGroup/customerGroupReducer";
import { getPriceType } from "../../../../redux/reducer/priceType/priceTypeReducer";
import { getCustomerRegion } from "../../../../redux/reducer/customerRegion/customerRegionReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminCustomerEdit() {
  // Navigate
  const navigate = useNavigate();
  const id = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.customerRegion.data);
  const group = useSelector((state) => state.customerGroup.data);
  const priceType = useSelector((state) => state.priceType.data);
  const data = useSelector((state) => state.customer.data);

  // Local State
  const [formData, setFormData] = useState({
    customerCode: "",
    typeOfCustomer: "",
    customerName: "",
    address: "",
    customerRegionId: "",
    timeOfPayment: "",
    pic: "",
    customerGroupId: "",
    priceTypeId: "",
    description: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      const x = data.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setFormData({
          customerCode: data.docs[x].customerCode
            ? data.docs[x].customerCode
            : "",
          typeOfCustomer: data.docs[x].typeOfCustomer
            ? data.docs[x].typeOfCustomer
            : "",
          customerName: data.docs[x].customerName
            ? data.docs[x].customerName
            : "",
          address: data.docs[x].address ? data.docs[x].address : "",
          customerRegionId: data.docs[x].customerRegionId
            ? data.docs[x].customerRegionId._id
            : "",
          customerRegionName: data.docs[x].customerRegionId
            ? data.docs[x].customerRegionId.regionName
            : "",
          timeOfPayment: data.docs[x].timeOfPayment
            ? data.docs[x].timeOfPayment
            : "",
          pic: data.docs[x].pic ? data.docs[x].pic : "",
          customerGroupId: data.docs[x].customerGroupId
            ? data.docs[x].customerGroupId._id
            : "",
          customerGroupName: data.docs[x].customerGroupId
            ? data.docs[x].customerGroupId.groupName
            : "",
          priceTypeId: data.docs[x].priceTypeId
            ? data.docs[x].priceTypeId._id
            : "",
          priceTypeName: data.docs[x].priceTypeId
            ? data.docs[x].priceTypeId.typeName
            : "",
          description: data.docs[x].description ? data.docs[x].description : "",
        });
      } else {
        toast.error("Data tidak ditemukan");
      }
      setFetch(false);
    }
  }, [fetch]);

  console.log(formData);
  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            customerCode: formData.customerCode,
            typeOfCustomer: formData.typeOfCustomer,
            customerName: formData.customerName,
            address: formData.address,
            customerRegionId: formData.customerRegionId,
            timeOfPayment: formData.timeOfPayment,
            pic: formData.pic,
            customerGroupId: formData.customerGroupId,
            priceTypeId: formData.priceTypeId,
            description: formData.description,
          },
          id: id.id,
          token: token,
        };
        dispatch(updateCustomer(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getCustomerById(dataGetById)).then((result) => {
              dispatch(customerActions.editCustomer(result.payload.data));
              toast.success(res.payload.message);
              navigate("/admin/customer");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const handleGenerateCode = () => {
    getData("/master/customer/generate-code", token, null)
      .then((res) => {
        setFormData({
          ...formData,
          customerCode: res.data.data,
        });
        toast.success(res.data.message);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (region.totalDocs !== region.docs.length && value === 1) {
        const getData = {
          params: {
            limit: region.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getCustomerRegion(getData));
      } else if (group.totalDocs !== group.docs.length && value === 2) {
        const getData = {
          params: {
            limit: group.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getCustomerGroup(getData));
      } else if (priceType.totalDocs !== priceType.docs.length && value === 3) {
        const getData = {
          params: {
            limit: priceType.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getPriceType(getData));
      }
    }
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT CUSTOMER
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE CUSTOMER
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 20, style: { background: "white" } }}
              required
              helperText={
                formData.customerCode.length > 0
                  ? /^[A-Za-z]{4}-\d{5}/.test(formData.customerCode)
                    ? ""
                    : "*Format Kode Customer salah"
                  : ""
              }
              size="small"
              error={
                formData.customerCode.length > 0
                  ? /^[A-Za-z]{4}-\d{5}/.test(formData.customerCode)
                    ? false
                    : true
                  : false
              }
              name="customerCode"
              onChange={handleChange}
              value={formData.customerCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
            <Button
              size="small"
              variant="contained"
              onClick={() => handleGenerateCode()}
            >
              <Settings />
            </Button>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TIPE CUSTOMER
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="typeOfCustomer"
              onChange={handleChange}
              value={formData.typeOfCustomer}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              <MenuItem value="cn">CN</MenuItem>
              <MenuItem value="non-cn">non-cn</MenuItem>
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              NAMA CUSTOMER
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              size="small"
              name="customerName"
              onChange={handleChange}
              value={formData.customerName}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              ALAMAT
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              size="small"
              name="address"
              onChange={handleChange}
              value={formData.address}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              REGION
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="customerRegionId"
              onChange={handleChange}
              value={formData.customerRegionId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.customerRegionName &&
                formData.customerRegionName.length > 0 && (
                  <MenuItem value={formData.customerRegionId} selected>
                    {formData.customerRegionName}
                  </MenuItem>
                )}
              {region.docs.length > 0 ? (
                region.docs.map(
                  (data, index) =>
                    (
                      <MenuItem value={data._id} key={index}>
                        {data.regionName}
                      </MenuItem>
                    )
                )
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TENOR PEMBAYARAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              size="small"
              name="timeOfPayment"
              onChange={handleChange}
              value={formData.timeOfPayment}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PIC
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              size="small"
              name="pic"
              onChange={handleChange}
              value={formData.pic}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              GROUP
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="customerGroupId"
              onChange={handleChange}
              value={formData.customerGroupId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(2),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.customerGroupName &&
                formData.customerGroupName.length > 0 && (
                  <MenuItem value={formData.customerGroupId}>
                    {formData.customerGroupName}
                  </MenuItem>
                )}
              {group.docs.length > 0 ? (
                group.docs.map(
                  (data, index) =>
                     (
                      <MenuItem value={data._id} key={index}>
                        {data.groupName}
                      </MenuItem>
                    )
                )
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TIPE HARGA
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="priceTypeId"
              onChange={handleChange}
              value={formData.priceTypeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(3),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.priceTypeName && formData.priceTypeName.length > 0 && (
                <MenuItem value={formData.priceTypeId}>
                  {formData.priceTypeName}
                </MenuItem>
              )}
              {priceType.docs.length > 0 ? (
                priceType.docs.map(
                  (data, index) =>
                    (
                      <MenuItem value={data._id} key={index}>
                        {data.typeName}
                      </MenuItem>
                    )
                )
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              Deskripsi
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" } }}
              required
              size="small"
              name="description"
              onChange={handleChange}
              value={formData.description}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/customer")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
